import React, { useState } from 'react';
import styled from '@emotion/styled';
import colors from '../../../styling/colors';

const POST_HOVER_HIDE_DELAY = 300;

const FlyoutContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  margin-right: 1rem;

  &:hover {
    .flyout-container {
      opacity: 1;
    }
  }
`;

const DisplayContent = styled.div`
  cursor: pointer;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FlyoutDisplayContainer = styled.div`
  ${({ isOpen, width, minWidth, maxWidth, maxHeight, horizontalAlign }) => `
    pointer-events: ${isOpen ? `auto` : 'none'};
    width: ${width};
    min-width: ${minWidth};
    ${horizontalAlign}: 0;
    ${maxWidth ? `max-width: ${maxWidth};` : null}
    ${maxHeight ? `max-height: ${maxHeight}; overflow-y: auto;` : null}
  `}
  display: block;
  position: absolute;
  bottom: 0;
  transform: translateY(100%);
  height: fit-content;
  z-index: 1;

  opacity: 0;
  transition: opacity ${POST_HOVER_HIDE_DELAY / 1000}s
    cubic-bezier(0.39, 0.58, 0.57, 1);
`;

const FlyoutContainerShim = styled.div`
  position: absolute;
  z-index: -1;
  width: 140%;
  height: 110%;
  left: -20%;
`;

const FlyoutContentContainer = styled.div`
  margin-top: 0.5rem;
  border: 1px solid ${colors('alto')};
  background-color: ${colors('white')};
`;

const FlyoutMenuHover = props => {
  const [isOpen, setIsOpen] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  const getCountTimeout = () => {
    setTimeout(() => {
      setTimeoutCount(countRef.current);
    }, 2000);
  };

  const {
    buttonContent,
    children,
    width,
    minWidth,
    maxHeight,
    horizontalAlign,
    isOverlapped,
  } = props;

  return (
    <FlyoutContainer
      onMouseEnter={() => {
        if (!isOverlapped) {
          setIsOpen(true);
          clearTimeout(timeoutId);
        }
      }}
      onMouseLeave={() => {
        setTimeoutId(
          setTimeout(() => {
            setIsOpen(false);
          }, POST_HOVER_HIDE_DELAY),
        );
      }}
    >
      <DisplayContent>{buttonContent}</DisplayContent>
      <FlyoutDisplayContainer
        className="flyout-container"
        width={width}
        maxHeight={maxHeight}
        minWidth={minWidth}
        horizontalAlign={horizontalAlign}
        isOpen={isOpen}
      >
        <FlyoutContainerShim />
        <FlyoutContentContainer>{children}</FlyoutContentContainer>
      </FlyoutDisplayContainer>
    </FlyoutContainer>
  );
};

FlyoutMenuHover.defaultProps = {
  minWidth: '0',
  width: '100%',
  horizontalAlign: 'left',
};

export default FlyoutMenuHover;
